export default "__VITE_PUBLIC_ASSET__66934c96__"